import { Container } from '@volkswagen-onehub/components-core';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleCarlineId } from 'src/bff';
import { CarlineWithOffers, Offer } from 'src/types';
import { useFeatureServices, useFaContent, useDisclaimerReference } from 'src/feature-app/hooks';
import React from 'react';
import { CarlineContext, OfferContainer } from 'src';

const getDisclaimers = (carline: CarlineWithOffers): string[] => carline?.ofertas?.map((offer) => offer.legal);

export default function OfferPage() {
  const { 'car-configuration': carConfigurationService } = useFeatureServices();
  const dispatch = useDispatch();
  const [carline, setCarline] = useState<CarlineWithOffers>(null);
  const [loading, setLoading] = useState(true);
  const faContent = useFaContent();

  const getOferta = async () => {
    let carlineId: string;

    if (carConfigurationService.get()) {
      carlineId = carConfigurationService.get().carlineId;
    } else {
      // // JUST FOR LOCAL DEVELOPMENT. CMS PROVIDES THE CARLINEID, BUT WE NEED TO PROVIDE IT OURSELVES IN LOCAL.
      carConfigurationService.set({
        carlineId: '30316',
        category: 'commercial',
      });
      carlineId = carConfigurationService.preliminaryConfigurations[0].carlineId;
    }

    let carline = await handleCarlineId(carlineId, faContent);

    if (carline) {
      const filtroFinanciacion = faContent?.filtroFinanciacion;
      const offerList: Offer[] = [];

      if (filtroFinanciacion !== 'Ninguno') {
        carline.ofertas.map((offer) => {
          if (filtroFinanciacion === 'My renting' && offer.myRenting === 1) {
            offerList.push(offer);
          }

          if (filtroFinanciacion === 'My way' && offer.myWay.activo === 1) {
            offerList.push(offer);
          }
        });

        carline = { ...carline, ofertas: offerList };
      }

      setCarline(carline);

      dispatch({ type: 'UPDATE_CARLINE', payload: carline });
    }

    setLoading(false);
  };

  useEffect(() => {
    getOferta();
  }, []);

  const legales = useDisclaimerReference(getDisclaimers(carline)); // Registro de todos los legales

  return loading ? null : (
    <>
      {carline ? (
        <CarlineContext.Provider value={carline}>
          <Container wrap={"always"}>
            <OfferContainer
              carline={carline}
              setShowOfferToFalse={() => {}}
              showOffer={true}
              showCard={false}
              mode="filter"
            />
          </Container>
        </CarlineContext.Provider>
      ) : null}
    </>
  );
}
function offerActiva(offer: Offer) {
  throw new Error('Function not implemented.');
}
